

    // Get the current URL
    var currentUrl = window.location.pathname;

    // Get all menu items
    var menuItems = document.querySelectorAll('menu__item a');

    // Loop through each menu item
    menuItems.forEach(function(item) {
        // Check if the href matches the current URL
        if (item.getAttribute('href') === currentUrl) {
            // If yes, add the "active" class
            item.classList.add('active');
        }
    });




